import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["removeCheckbox"]

  remove(e) {
    e.preventDefault()
    this.removeCheckboxTarget.checked = true
    this.element.classList.add("hidden")
  }
}
